import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SyncState {
  isSync: boolean;
}

const initialState: SyncState = {
  isSync: false,
};

const settingSyncSlice = createSlice({
  name: "settingSync",
  initialState,
  reducers: {
    setIsSync(state, action: PayloadAction<boolean>) {
      state.isSync = action.payload;
    },
  },
});

export const { setIsSync } = settingSyncSlice.actions; // ✅ named export
export default settingSyncSlice.reducer;
